<template>
    <div class="py-lg text-xxs border-b border-gray-200 last:border-b-0">
        <div class="flex flex-col md:flex-row md:items-end">
            <div class="w-full md:w-3/5">
                <rating-bar :rating-label="ratingLabel" :sub-rating-average="ratingTypeAverages ? ratingTypeAverages.all : null">
                    <button
                        type="button"
                        class="ml-lg text-xxs underline hover:text-green-500"
                        @click="toggled = ! toggled"
                    >
                        <span v-if="toggled">Dölj detaljer</span>
                        <span v-else-if="ratingTypeAverages">Visa detaljer</span>
                    </button>
                </rating-bar>
            </div>

            <div class="flex-none mt-xl mb-xs md:mt-0 md:ml-auto">
                <rate-stars
                    v-if="existingRating"
                    :rating-type="ratingType"
                    :existing-rating="existingRating"
                    :product="product"
                    :user-has-rated="userHasRated"
                    :user-diet="userDiet"
                    @product-and-rating-updated="updateProductAndRating"
                    @rating-error="ratingError => $emit('rating-error', ratingError)"
                />
            </div>
        </div>

        <div
            v-if="toggled"
            class="mt-lg mb-xs text-xxs"
        >
            <ul class="mb-0 border-l border-pink-500 leading-relaxed">
                <li class="pl-lg font-semibold">Kostbaserat genomsnitt</li>
                <li class="pl-lg flex justify-between md:justify-start md:items-center">
                    {{ dietLabels.meat }}:
                    <span class="ml-sm text-xs">{{ formatNumber(ratingTypeAverages.meat) }}</span>
                </li>
                <li class="pl-lg flex justify-between md:justify-start md:items-center">
                    {{ dietLabels.plants }}:
                    <span class="ml-sm text-xs">{{ formatNumber(ratingTypeAverages.plants) }}</span>
                </li>
                <li class="pl-lg flex justify-between md:justify-start md:items-center">
                    Okänd kost:
                    <span class="ml-sm text-xs">{{ formatNumber(ratingTypeAverages.unknown) }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import RateStars from './RateStars';

    export default {
        components: {
            RateStars,
        },

        props: {
            product: {
                type: Object,
                required: true,
            },
            existingRating: {
                type: Object,
                default: null,
            },
            ratingType: {
                type: String,
                required: true,
            },
            ratingLabel: {
                type: String,
                required: true,
            },
            userHasRated: {
                type: Boolean,
                required: true,
            },
            userDiet: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                toggled: false,
                dietLabels: window.App.dietLabels,
            };
        },

        computed: {
            ratingTypeAverages() {
                if (this.product.additional_data
                    && this.product.additional_data.rating_type_averages
                ) {
                    return this.product.additional_data.rating_type_averages[this.ratingType];
                }

                return null;
            },
        },

        methods: {
            updateProductAndRating(product, rating) {
                this.$emit('product-and-rating-updated', product, rating);
            },
        },

    };
</script>
